import React from 'react';

import {useLastLocationEffect} from '../../../hooks/use-last-location-effect';

import {
    GlobalVersionProps,
    GlobalVersionsLoadedChecker
} from '../../gv-management-panel/global-versions-loaded-checker';
import {getLineSeparator} from '../../../utils/get-client-os';
import {ExploreViewLayout} from './explore-view-layout';
import {useGlobalVersion} from '../../../providers/version/use-global-version';

interface Props {
    globalVersionProps: ReturnType<typeof useGlobalVersion>;
}

export const ExploreRoute = ({globalVersionProps}: Props) => {
    useLastLocationEffect({
        path: '/documents/explore',
        lsKey: 'documents.explore.lastLocation'
    });

    return (
        <GlobalVersionsLoadedChecker
            errorText={`At least one Knowledge Base global version ${getLineSeparator()} is required to explore documents`}
            globalVersionProps={globalVersionProps}
        >
            {({currentGlobalVersionData, globalVersions}: GlobalVersionProps) => (
                <ExploreViewLayout
                    globalVersions={globalVersions}
                    selectedGlobalVersion={currentGlobalVersionData}
                />
            )}
        </GlobalVersionsLoadedChecker>
    );
};
